import React from "react";

const Authapi = React.createContext({
    auth: false,
    authControl: () => {}
});

export default Authapi;